import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import GreenifiedButton from "@/components/common/GreenifiedButton.vue";
import { FormFields } from "@/library/types/structure/formStructure";
import { RadioFieldType } from "@/library/types/structure/subfieldTypes";
import { ref } from "vue";

type MultipleRadioFieldProps = {
  presetMultipleRadioFieldValues: FormFields["key"];
  multipleRadioField: RadioFieldType | null;
  optionKey: string | number;
  option: string;
  checked: boolean;
  thinButton: boolean;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'MultipleRadioField',
  props: {
    presetMultipleRadioFieldValues: { default: () => ({}) },
    multipleRadioField: { default: null },
    optionKey: { default: "" },
    option: { default: "" },
    checked: { type: Boolean, default: false },
    thinButton: { type: Boolean, default: false }
  },
  emits: ["update:presetMultipleRadioFieldValues"],
  setup(__props: any, { emit: __emit }) {

const multipleRadioFieldProps = __props;

const emit = __emit;

const localMultipleRadioFieldValues = ref(
  multipleRadioFieldProps.presetMultipleRadioFieldValues
);

const inputRadio = (key: string) => {
  localMultipleRadioFieldValues.value = key;
  emit(
    "update:presetMultipleRadioFieldValues",
    localMultipleRadioFieldValues.value
  );
};

return (_ctx: any,_cache: any) => {
  return (__props.multipleRadioField)
    ? (_openBlock(), _createBlock(GreenifiedButton, {
        key: 0,
        inputType: "radio",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (inputRadio(String(__props.optionKey)))),
        text: __props.option,
        inputId: __props.multipleRadioField.key + '-' + __props.optionKey,
        inputName: __props.multipleRadioField.key,
        inputValue: __props.option,
        btnStyle: __props.checked ? 'black' : 'normal',
        size: __props.thinButton ? 'thin' : 'full',
        inputRequired: __props.multipleRadioField.required === 0 ? false : true
      }, null, 8, ["text", "inputId", "inputName", "inputValue", "btnStyle", "size", "inputRequired"]))
    : _createCommentVNode("", true)
}
}

})